
let googleChartsPromise = null

export function loadGoogleCharts(packages = ['corechart']) {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Charts cannot load on the server.'))
  }

  if (window.google && window.google.charts) {
    return new Promise((resolve) => {
      window.google.charts.load('current', { packages, language: 'de' })
      window.google.charts.setOnLoadCallback(() => resolve(window.google))
    })
  }

  if (!googleChartsPromise) {
    googleChartsPromise = new Promise((resolve, reject) => {
      const existing = document.getElementById('google-charts-loader')
      if (existing) {
        existing.addEventListener('load', afterScriptLoaded)
        existing.addEventListener('error', () => reject(new Error('Failed to load Google Charts loader.')))
      } else {
        const script = document.createElement('script')
        script.id = 'google-charts-loader'
        script.src = 'https://www.gstatic.com/charts/loader.js'
        script.async = true
        script.defer = true
        script.addEventListener('load', afterScriptLoaded)
        script.addEventListener('error', () => reject(new Error('Failed to load Google Charts loader.')))
        document.head.appendChild(script)
      }

      function afterScriptLoaded() {
        window.google.charts.load('current', { packages, language: 'de' })
        window.google.charts.setOnLoadCallback(() => resolve(window.google))
      }
    })
  }

  return googleChartsPromise.then((g) => {
    return new Promise((resolve) => {
      g.charts.load('current', { packages })
      g.charts.setOnLoadCallback(() => resolve(g))
    })
  })
}
